import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import DraftClosedDeadlineColumn, {
    DraftClosedDeadlineColumnData,
    DraftClosedDeadlineColumnDataKeys,
    DraftClosedDeadlineColumnDisplayOptions,
} from '../../../../components/draft-closed-deadline-column/DraftClosedDeadlineColumn';
import { EditedBySimpleTextColumnTemplateDefaultProps } from '../edited-by-simple-text-column-template/EditedBySimpleTextColumnTemplate';

const DraftClosedDeadlineColumnTemplate = (props: CellTemplateProps) => {
    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <DraftClosedDeadlineColumn
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={props.data}
                        defaultProps={EditedBySimpleTextColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </React.Fragment>
    );
};

export const DraftClosedDeadlineColumnTemplateDefaultProps =
    {} as DraftClosedDeadlineColumnDisplayOptions;

export const DraftClosedDeadlineColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type DraftClosedDeadlineColumnTemplateData = DraftClosedDeadlineColumnData & {};

export const DraftClosedDeadlineColumnTemplateDataKeys = [...DraftClosedDeadlineColumnDataKeys];

export default DraftClosedDeadlineColumnTemplate;
